"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealMeatFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealMeatFilled = function MealMeatFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.83 18.269c.625 2.563.562 4.716-1.318 6.836l2.782 3.288a2.5 2.5 0 111.822 4.406 2.5 2.5 0 11-4.565-1.952l-3.108-3.367c-3.479 1.681-6.705-.117-10.43-2.194l-.002-.002L11.5 25a21.706 21.706 0 01-1.367-.877c.026-.066.056-.136.09-.21a9.354 9.354 0 011.295-2.023c.574-.688 1.229-1.277 1.893-1.634.645-.347 1.238-.449 1.783-.303l.013.005.146.051a22.396 22.396 0 002.372.656c1.487.323 3.496.6 5.416.325 1.853-.265 2.999-1.5 3.69-2.721z",
    fill: "#97BA1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.877 15.138a8.668 8.668 0 01-.484 1.53c-.513 1.198-1.305 2.166-2.535 2.342-1.58.226-3.32.002-4.708-.3a20.42 20.42 0 01-2.146-.592 10.884 10.884 0 01-.12-.042l-.027-.01-.006-.002-.038-.014-.038-.012c-1.196-.341-2.343-.065-3.312.457-.96.517-1.805 1.303-2.481 2.115-.613.735-1.12 1.53-1.471 2.246C1.253 16.474 4.495 8.14 8.038 5.562c3.921-2.852 13.29-3.55 17.839 9.576z",
    fill: "#97BA1E"
  }));
};

exports.MealMeatFilled = MealMeatFilled;
var _default = MealMeatFilled;
exports.default = _default;